import { Problem } from "../types/Problem";

export const requestedProblems = {
	problemOfTheDay: null,
	suggestedProblem: null,
} as {
	problemOfTheDay: Problem | null;
	suggestedProblem: Problem | null;
};
